<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207_price","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"","showVariationProductImage":false,"mapFeatureName":null},...{}}' :style='"margin-top:130px"' class="container single-product-en" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201,mDiv },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
